<prism-anchor-position
	id="sh-header-toolbar-notifications-anchor"
	[visible]="isNotificationsEnabled()"
	*transloco="let t"
>
	<prism-badge [disabled]="notificationsCount() <= 0" id="sh-header-toolbar-notifications-badge" slot="anchor-target">
		<prism-icon-button
			icon="notifications"
			label="notifications"
			tooltip-disabled
			(click)="openNotifications()"
			id="sh-header-toolbar-notifications-icon"
			[label]="t('cloud.shared.notification.title')"
		>
		</prism-icon-button>
	</prism-badge>
	<prism-overlay title="">
		@if (isNotificationsEnabled()) {
			<sh-notifications-popup
				[application]="application"
				(closeNotificationPopup)="handlePopupClose()"
			></sh-notifications-popup>
		}
	</prism-overlay>
</prism-anchor-position>
